import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { EvkMainFilterPage, EvkOption, EvkPageComponentBase, MessageCrudService } from "@evomatik/evk-common";
import { EvkExpedienteModel } from "../../models/evk-expediente.model";
import { ExpedientesPageService } from "../../services/expedientes-page.service";
import { ExpedientesDeleteService } from "./expedientes-delete.service";
import { AuthUtils, EvkSecurityControlDataService } from "@evomatik/evk-seguridad";
import { MatDialog } from "@angular/material/dialog";
import { ActualizacionDialogComponent } from "../sub-components/actualizacion-dialog/actualizacion-dialog.component";
import { EvkExpedienteConfigModel } from "../../models/evk-expediente-config.model";
import { ExpedienteUpdateService } from "../../services/expediente-update.service";
import { take } from "rxjs/operators";
import * as _ from 'lodash';
import { MatSelectChange } from '@angular/material/select';
import { TipoExpedienteEnum } from '../../enums/tipo-expediente-enum';
import { CatalogosService } from '@evomatik/evk-content';
import { ExpedienteUpdateEstatusService } from '../../services/expediente-update-estatus';
import { EstatusDesaparicionEnum } from '../../enums/estatus-localizacion-enum';
import { WizardExpedientesService } from '../../services/wizard-expedientes.service';
import { ExpedienteEstatusService } from '../../services/expediente-estatus.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'lib-expedientes-page',
    templateUrl: './expedientes-page.component.html',
    styleUrls: ['./expedientes-page.component.scss'],
    providers: [EvkMainFilterPage, ExpedientesDeleteService, ExpedientesPageService, ExpedienteUpdateEstatusService],
    encapsulation: ViewEncapsulation.None
})
export class ExpedientesPageComponent extends EvkPageComponentBase<EvkExpedienteModel> implements OnInit, OnDestroy {

    columns: string[];

    @Input()
    canAdd = true//('CREAR_EXPEDIENTE');

    @Input()
    tipoConfiguracionExpediente: string;

    @Input()
    configExpediente: EvkExpedienteConfigModel = new EvkExpedienteConfigModel();

    @Output()
    addExpediente: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    editExpediente: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @Input()
    biosphereConfig: any;

    @Input()
    descargaZipByFolio: boolean;

    @Input()
    skipByVersion: boolean;

    @Input()
    titulo = 'MiTCh';

    @Input()
    subTitulo = 'Mi Trámite Chihuahua';

    catalogoEstatus: EvkOption[];
    tipoDeAlerta: EvkOption[];
    filtroSeleccionado: String;
    valoresFiltros = {};

    notificacionSubscription: Subscription;

    filters = [
        {
            id: 'folio',
            title: 'Número de folio'
        },
        {
            id: 'fechaDeCreacion',
            title: 'Fecha de creación'
        }
    ];

    constructor(
        public pageService: ExpedientesPageService,
        public messageCrudService: MessageCrudService,
        public expedientesDeleteService: ExpedientesDeleteService,
        public expedienteUpdateService: ExpedienteUpdateService,
        private catalogoService: CatalogosService,
        private expedienteUpdateEstatusService: ExpedienteUpdateEstatusService,
        private evkSecurity: EvkSecurityControlDataService,
        public dialog: MatDialog,
        private wizardExpedientesService: WizardExpedientesService,
        private expedienteEstatusService: ExpedienteEstatusService
    ) {
        super(pageService, EvkExpedienteModel);
        this.columns = ['folio', 'fechaCreacion', 'acciones'];
    }

    ngOnInit(): void {
        this.identifyPerfil();
        this.setDefaultFilters();
        super.ngOnInit();
        this.traduccionPaginador();
        this.catalogoService.getByDiscriminator('ESTATUS-LOCALIZACION-ZACATECAS')
            .subscribe(respuesta => {
                this.catalogoEstatus = respuesta;
            });
        this.catalogoService.getByDiscriminator('TIPO-ALERTA-ZACATECAS')
            .subscribe(respuesta => {
                this.tipoDeAlerta = respuesta;
            });

        /* Evento de accion de notificar*/
        this.notificacionSubscription =
            this.expedienteEstatusService.notificacionEvent.subscribe(
                (e) =>{
                    this.page();
                }
            );

    }

    ngOnDestroy(): void {
        this.notificacionSubscription.unsubscribe();
    }

    onDateInputed($event: any) {
        const dateString = $event.target.value;
        const parts = dateString.split('/');
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        this.valoresFiltros["fechaDeCreacion"] = new Date(year, month -1, day);

    }

    traduccionPaginador() {
        this.paginator._intl.itemsPerPageLabel = 'Registros por página';
        this.paginator._intl.nextPageLabel = 'Siguiente página';
        this.paginator._intl.previousPageLabel = 'Página anterior';
        this.paginator._intl.firstPageLabel = 'Primera página';
        this.paginator._intl.lastPageLabel = 'Ultima página';
    }

    add() {
        this.addExpediente.emit();
    }

    edit(row: EvkExpedienteModel) {
        this.editExpediente.emit(row);
    }

    delete(row: EvkExpedienteModel) {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de eliminar este registro? ',
            goonbtn: 'Eliminar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.expedientesDeleteService.deleteExpediente(row.id).subscribe(() => {
                this.messageCrudService.snackbarMessage('Se ha eliminado el registro de forma exitosa.');
                confirmDialog.close();
                this.page();
            }, () => {
                this.messageCrudService.snackbarMessage('No se ha podido eliminar el registro.');
                confirmDialog.close();
                this.page();
            });
        });
    }

    /**
     * @deprecated
     * @param row
     * @returns
     */
    validarTitulo(row: EvkExpedienteModel) {
        if (row.configuracionExpediente && row.configuracionExpediente.usoGenerales) {
            if (row.secciones != null && row.secciones.length > 0 && row.secciones[0] && row.secciones[0].propiedades && row.secciones[0].propiedades.titulo) {
                return row.secciones[0].propiedades.titulo;
            } else {
                return row.configuracionExpediente.nombre;
            }
        } else {
            return row.configuracionExpediente.nombre;
        }
    }

    /**
     * Valida el dato del folio a mostrar
     * @param row
     * @returns
     */
    validarFolio(row: EvkExpedienteModel) {
        return this.wizardExpedientesService.validarFolio(row);
    }

    /**
     * @deprecated
     * @param row
     * @returns
     */
    validarTipoUsuario(row: EvkExpedienteModel) {
        return _.get(row, 'configuracionExpediente.nombre', '');

    }

    /**
     * @deprecated
     * @param row
     * @returns
     */
    validarActualizar(row: EvkExpedienteModel) {
        return row.configuracionExpediente.actualizar != null && row.configuracionExpediente.actualizar.length > 0;
    }

    actualizar(row: EvkExpedienteModel) {
        const dialogRef = this.dialog.open(ActualizacionDialogComponent, {
            width: '50%',
            panelClass: 'create-component-dialog',
            disableClose: true,
            data: row.configuracionExpediente.actualizar
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const newConfiguracion = new EvkExpedienteConfigModel();
                newConfiguracion.id = result;
                row.configuracionExpediente = newConfiguracion;
                this.expedienteUpdateService.edit(row).pipe(take(1)).subscribe(
                    () => {
                        this.messageCrudService.snackbarMessage('Se ha actualizado con éxito');
                        this.page();
                    }, (e) => {
                        console.log("aqui error guardar")
                        console.log(e);
                        this.messageCrudService.snackbarMessage(e && e?.message? e?.message : 'No se ha podido actualizar');
                        this.page();
                    }
                );
            }
        });
    }

    filterBy() {
        const key = this.filtroSeleccionado ? this.filtroSeleccionado.toString() : null;
        if (key) {
            this.pageService.deleteAllFilter();
            this.setDefaultFilters();
            const value = this.valoresFiltros[key];
            this.pageService.addFilter(key, value);
            this.page();
        }
    }

    onFiltroChange($event: MatSelectChange) {
        if ($event.value) {
            this.filtroSeleccionado = $event.value;
        }
        if (!$event.value) {
            this.filtroSeleccionado = null;
            this.valoresFiltros = {};
            this.pageService.deleteAllFilter();
            this.setDefaultFilters();
            this.page();
        }
    }

    setDefaultFilters(){

        if(this.configExpediente){
            this.pageService.addFilter("tipoExpediente", this.configExpediente.id);
        }

        // if (AuthUtils.hasRol('AREA_BUSQUEDA')) {
        //     this.pageService.addFilter("perfil", 'AREA_BUSQUEDA');
        // }
    }

    identifyPerfil(){
        // if (AuthUtils.hasRol('AREA_BUSQUEDA')) {
        //     this.areaBusqueda = true;
        // }
    }

    validarData(data: any) {
        return this.tipoData(data);
    }

    tipoData(field: any) {
        if (field) {
            if (typeof JSON) {
                return field.label ? field.label : field.nombre;
            } else {
                return field;
            }
        }
    }

}
